import { useEffect, useState } from "react";
import {
  deleteVersionAPI,
  getVersion,
  getVersionHistory,
} from "../../services/shop.service";
import MaterialTable from "material-table";
import moment from "moment";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { toast } from "react-hot-toast";

function VersionList(props: any) {
  const [shopListArray, setShopListArray] = useState([]);
  const [versionData, setVersionData] = useState({
    mobile_version: 0,
    electorn_version: 0,
  });
  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      getList();
      localStorage.removeItem("VERSION_TYPE");
      getVersion()
        .then((res: any) => setVersionData(res?.data))
        .catch((err) => console.log(err));
    } else {
      props.history.push("/login");
    }
  }, []);

  const getList = () => {
    getVersionHistory()
      .then((res: any) => setShopListArray(res?.data))
      .catch((err) => console.log(err));
  };

  const editShop = (version_number: string, version_type: string) => {
    const shopDetail = shopListArray.filter(
      (item: any) =>
        item.version_number === version_number &&
        item.version_type === version_type
    )[0];
    props.history.push({
      pathname: `/version/edit/${version_type}/${version_number}`,
      details: shopDetail,
    });
  };
  const deleteVersion = async (id: string) => {
    await deleteVersionAPI(id)
      .then((res: any) => {
        getList();
        toast.success(res.message);
      })
      .catch((err: any) => toast.error(err.message));
  };
  return (
    <>
      <MaterialTable
        style={{ padding: "20px" }}
        title={
          <div className="page-title d-flex justify-content-between">
            <button
              className="btn btn-primary primary-out"
              type="submit"
              onClick={() => {
                localStorage.setItem("VERSION_TYPE", "MOBILE");
                props.history.push("/version/add");
              }}
            >
              Mobile Version
            </button>
            <button
              className="btn btn-primary primary-out ml-2"
              type="submit"
              onClick={() => {
                localStorage.setItem("VERSION_TYPE", "DESKTOP");
                props.history.push("/version/add");
              }}
            >
              Desktop Version
            </button>
            <h5 className="ml-2">
              <b>MOBILE-: {versionData?.mobile_version}</b>
            </h5>
            <h5 className="ml-2">
              <b>ELECTON-: {versionData?.electorn_version}</b>
            </h5>
          </div>
        }
        localization={{
          body: {
            emptyDataSourceMessage: (
              <div>
                <b>No Data Loaded</b>
              </div>
            ),
          },
        }}
        columns={[
          {
            title: "Version Type",
            field: "version_type",
          },
          {
            title: "Version Number",
            field: "version_number",
          },
          {
            title: "Updated By",
            field: "updated_by",
          },
          {
            title: "Description",
            field: "description",
          },
          {
            title: "Created Date",
            field: "updated_date",
            render: (rowData) =>
              rowData.updated_date && (
                <>{moment(rowData.updated_date).format("DD-MM-YYYY")}</>
              ),
          },
          {
            title: "Action",
            field: "action",
            render: (rowData: any) => (
              <>
                <div className="d-flex">
                  <Tooltip title="Edit">
                    <IconButton
                      aria-label="edit"
                      onClick={() =>
                        editShop(rowData?.version_number, rowData?.version_type)
                      }
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Soft Delete">
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteVersion(rowData?.id)}
                    >
                      <DeleteIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                </div>
              </>
            ),
          },
        ]}
        data={
          shopListArray &&
          shopListArray.map((shopListObj: any, index) => {
            return {
              id: shopListObj.id,
              version_type: shopListObj?.version_type,
              version_number: shopListObj?.version_number,
              updated_by: shopListObj.updated_by,
              description: shopListObj.description,
              updated_date: shopListObj.updated_date,
            };
          })
        }
        options={{
          paging: true,
          pageSize: 10,
          pageSizeOptions: [50, 100, 200],
          sorting: true,
          actionsColumnIndex: -1,
          loadingType: "linear",
        }}
      />
    </>
  );
}

export default VersionList;
